import React, { Component } from 'react';
import YouTube from 'react-youtube';
import { Grid, Row, Col, Thumbnail, Button, Panel, PanelGroup, Image, Collapse, Fade, Carousel } from 'react-bootstrap';
import { AwesomeButton, AwesomeButtonSocial } from 'react-awesome-button';
import { AutoAffix } from 'react-overlays';

import 'react-awesome-button/dist/styles.css';
import 'react-awesome-button/dist/themes/theme-blue.css';

import PanelContent from './PanelContent';
import PanelBlurb from './PanelBlurb';

import StarsContent from './StarsContent';
import StarsBlurb from './StarsBlurb';

import TinyEngineContent from './TinyEngineContent';
import TinyEngineBlurb from './TinyEngineBlurb';

import NodeContent from './NodeContent';
import NodeBlurb from './NodeBlurb';

import SpoiledTomatillosContent from './SpoiledTomatillosContent';
import SpoiledTomatillosBlurb from './SpoiledTomatillosBlurb';

import MyCol from './MyCol';

import './ThumbnailGridFlex.css'

export default class ThumbnailGrid extends React.Component {
    constructor(props, context) {
      super(props, context);

      this.handleSelect = this.handleSelect.bind(this);

      this.state = {
        activeKey: '0',
        player: []
      };

      this._onReady = this._onReady.bind(this);
      this.stopAllVideos = this.stopAllVideos.bind(this);
    }

    _onReady(event) {
      const player = this.state.player;
      player.push(event.target);
      this.setState({
        player: player
      });
    }

    routerWillLeave(nextLocation) {
      document.body.style.backgroundImage = "none";
    }

    componentWillUnmount() {
      document.body.style.backgroundImage = "none";
    }

    stopAllVideos() {
      for (let ii = 0; ii < this.state.player.length; ii++) {
        this.state.player[ii].stopVideo();
      }
    }

    handleSelect(activeKey) {
      if (activeKey !== this.state.activeKey) {
        this.stopAllVideos();
      }


      this.setState({ activeKey });

      // let pixelTopOffset = 0;
      // let pixelsPerRow = 650;
      // let boxesPerRow = 3;
      // let pixelTop = pixelTopOffset + (pixelsPerRow * (Math.floor( (activeKey - 1) / boxesPerRow) + 1));
      let pixelTop = (activeKey > 0) ? 1000 : 0;
      // // alert(" " + parseInt( (activeKey - 1) / boxesPerRow));
      // // alert("moving to " + pixelTop);
      //
      setTimeout(function(){
          window.scrollTo({
          top: pixelTop,
          behavior: "smooth"
        });
      }, 250);

      let bgImg = "none";
      if (activeKey === '1') {
        bgImg = "url('assets/tts/tts-bg.gif')";
      }
      else if (activeKey === '3') {
        bgImg = "url('assets/tinyengine/asteroids.gif')";
      }
      else if (activeKey === '4') {
        bgImg = "url('assets/node/node.gif')";
      }
      else {
        bgImg = "none";
      }
      document.body.style.backgroundImage = bgImg;
    }

    render() {
      return (
        <div>
          {/* this.state.activeKey === '1' ?
            <Image src='assets/tts/bounce.gif' className='topImage'/>
          : null */}

          <div>
            <div className='myGrid'>
              <div className='myFlex'>
                <div className='myCol'>
                  <div className='myBox'>
                        <Thumbnail className="my-thumbnail" src="assets/tts/title.png" alt="242x200">
                            <StarsBlurb className="blurb"/>

                            <AwesomeButton type="primary" action={() => this.handleSelect("1")}>Show me more!</AwesomeButton>
                        </Thumbnail>
                  </div>

                  <div className='myBox'>
                        <Thumbnail className="my-thumbnail" src="assets/node/screenshot-1.png" alt="242x200">
                            <NodeBlurb className="blurb"/>

                            <AwesomeButton type="primary" action={() => this.handleSelect("4")}>Show me more!</AwesomeButton>
                        </Thumbnail>
                  </div>

                </div>
              <div className='myCol'>
                <div className='myBox'>
                    <Thumbnail className="my-thumbnail" src="assets/tomatillos/screenshot-1.jpg" alt="242x200">
                      <SpoiledTomatillosBlurb className="blurb"/>
                      <Fade in={this.state.activeKey !== "2"} >
                        <AwesomeButton type="primary" action={() => this.handleSelect("2")}>Show me more!</AwesomeButton>
                      </Fade>
                    </Thumbnail>
                </div>

              </div>
              <div className='myCol'>
                <div className='myBox'>
                    <Thumbnail className="my-thumbnail" src="assets/tinyengine/title.png" alt="242x200" >
                      <TinyEngineBlurb className="blurb"/>

                      <Fade in={this.state.activeKey !== "3"} >
                        <AwesomeButton type="primary" action={() => this.handleSelect("3")}>Show me more!</AwesomeButton>
                      </Fade>
                    </Thumbnail>
                </div>

              </div>

            </div>
            </div>
          </div>

          <div className="show-hide-panel">
            <Collapse in={this.state.activeKey === "1"} >
              <Panel>
                <Panel.Heading>
                  <div className="btn-group pull-right">
                    <AwesomeButtonSocial type="github" href="https://github.com/GCSChris/Through-The-Stars">Source</AwesomeButtonSocial>
                    <AwesomeButton href="https://chrisdinome.itch.io/through-the-stars">Download</AwesomeButton>
                  </div>

                  <Panel.Title>Through the Stars</Panel.Title>
                </Panel.Heading>

                <Panel.Body>
                  <div className="panel-body-left">
                    <div className="panel-body-text">

                    <StarsContent/>

                    <AwesomeButton type="secondary" action={() => this.handleSelect("0")}>Hide</AwesomeButton>
                    <AwesomeButtonSocial type="github" href="https://github.com/GCSChris/Through-The-Stars">Source</AwesomeButtonSocial>
                    <AwesomeButton href="https://chrisdinome.itch.io/through-the-stars">Download</AwesomeButton>

                    </div>
                  </div>

                  <div className="panel-body-right">

                    <div className="panel-body-video">
                      <YouTube
                        className="yt-video"
                        videoId="G8gfMIPzoUM"
                        onReady={this._onReady}
                      />
                    </div>
                  </div>

                  <Grid className="screenshots-group">
                    <Row>
                        <Image src="assets/tts/screenshot-1.png" className="screenshot" rounded/>
                        <Image src="assets/tts/screenshot-2.png" className="screenshot" rounded/>
                        <Image src="assets/tts/screenshot-3.png" className="screenshot" rounded/>
                        <Image src="assets/tts/screenshot-4.png" className="screenshot" rounded/>
                    </Row>
                  </Grid>

                  <AwesomeButton type="secondary" action={() => this.handleSelect("0")}>Hide</AwesomeButton>
                  <AwesomeButtonSocial type="github" href="https://github.com/GCSChris/Through-The-Stars">Source</AwesomeButtonSocial>
                  <AwesomeButton href="https://chrisdinome.itch.io/through-the-stars">Download</AwesomeButton>

                </Panel.Body>

              </Panel>
            </Collapse>

            <Collapse in={this.state.activeKey === "2"} >
              <Panel>
                <Panel.Heading>
                  <div className="btn-group pull-right">
                  </div>

                  <Panel.Title>Spoiled Tomatillos</Panel.Title>

                </Panel.Heading>

                <Panel.Body>
                  <div className="panel-body-left">
                    <div className="panel-body-text">
                      <SpoiledTomatillosContent/>
                      <AwesomeButton type="secondary" action={() => this.handleSelect("0")}>Hide</AwesomeButton>
                    </div>
                  </div>

                  <div className="panel-body-right">
                    <div className="panel-body-video">
                      <YouTube
                        classNa me="yt-video"
                        videoId="tZWS0Us9t3c"
                        onReady={this._onReady}
                      />
                    </div>

                    <div className="screenshots-group-flex">
                          <Image src="assets/tomatillos/screenshot-1.jpg" className="screenshot-border" rounded/>
                          <Image src="assets/tomatillos/screenshot-3.png" className="screenshot-border" rounded/>
                          <Image src="assets/tomatillos/screenshot-2.png" className="screenshot-border" rounded/>
                    </div>

                  </div>

                </Panel.Body>
              </Panel>
            </Collapse>

            <Collapse in={this.state.activeKey === "3"} >
              <Panel>
                <Panel.Heading>
                  <div className="btn-group pull-right">
                    <AwesomeButtonSocial type="github" href="https://github.com/GCSChris/TinyEngine">Source</AwesomeButtonSocial>
                    <AwesomeButton href="https://tinyenginecs4850.wordpress.com/">Website</AwesomeButton>
                  </div>

                  <Panel.Title>TinyEngine</Panel.Title>
                </Panel.Heading>

                <Panel.Body>
                  <div className="panel-body-left">
                    <div className="panel-body-text">

                    <TinyEngineContent/>

                    <AwesomeButton type="secondary" action={() => this.handleSelect("0")}>Hide</AwesomeButton>
                    <AwesomeButtonSocial type="github" href="https://github.com/GCSChris/TinyEngine">Source</AwesomeButtonSocial>
                    <AwesomeButton href="https://tinyenginecs4850.wordpress.com/">Website</AwesomeButton>

                    </div>
                  </div>

                  <div className="panel-body-right">

                    <div className="panel-body-video">
                      <YouTube
                        className="yt-video"
                        videoId="TnI-HnQDgd8"
                        onReady={this._onReady}
                      />
                    </div>
                  </div>

                  <Grid >
                    <Row>
                      <div>
                        <Image src="assets/tinyengine/spaceinvaders.png" className="screenshot" rounded/>
                      </div>
                    </Row>
                  </Grid>
                </Panel.Body>
              </Panel>
            </Collapse>

            <Collapse in={this.state.activeKey === "4"} >
              <Panel>
                <Panel.Heading>
                  <div className="btn-group pull-right">
                    <AwesomeButtonSocial type="github" href="https://github.com/Zilby/SoundLemmings">Source</AwesomeButtonSocial>
                    <AwesomeButton href="https://globalgamejam.org/2017/games/node">GGJ Website</AwesomeButton>
                  </div>

                  <Panel.Title>Node</Panel.Title>
                </Panel.Heading>

                <Panel.Body>
                  <div className="panel-body-left">
                    <div className="panel-body-text">

                    <NodeContent/>

                    <AwesomeButton type="secondary" action={() => this.handleSelect("0")}>Hide</AwesomeButton>
                    <AwesomeButtonSocial type="github" href="https://github.com/Zilby/SoundLemmings">Source</AwesomeButtonSocial>
                    <AwesomeButton href="https://globalgamejam.org/2017/games/node">GGJ Website</AwesomeButton>

                    </div>
                  </div>

                  <div className="panel-body-right">

                    <div className="panel-body-video">
                      <YouTube
                        className="yt-video"
                        videoId="nIYjzsYEZ3E"
                        onReady={this._onReady}
                      />
                    </div>
                  </div>

                  <Grid className="screenshots-group-right">
                    <Row>
                        <Image src="assets/node/screenshot-1.png" className="screenshot2" rounded/>
                        <Image src="assets/node/screenshot-2.png" className="screenshot2" rounded/>
                    </Row>
                  </Grid>
                </Panel.Body>
              </Panel>
            </Collapse>

            <div>
            {/*<Grid className="myGrid">
              <Row>
                <div>
                  <div>
                    <Thumbnail className="my-thumbnail" src="assets/screenshot-2.jpg" alt="242x200" rounded>
                      <h3>Thumbnail #4</h3>
                      <p>Blurb #4 - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris felis sem, tristique et porta vitae, rhoncus eu turpis. Proin convallis, nisi sed feugiat cursus, orci magna euismod quam, et porttitor est mi vel nisl. Curabitur in finibus ligula, vel venenatis elit. Nulla venenatis facilisis commodo. Nam volutpat mollis tincidunt. Nullam sit amet nisl iaculis, finibus nibh a, varius est. Duis eget vestibulum erat, at porta leo. Fusce neque diam, pharetra rutrum eros vitae, rhoncus pharetra mi. Praesent mauris sem, lacinia vitae orci at, rutrum ultrices ipsum. Praesent mattis, nunc eget suscipit elementum, erat sapien lacinia metus, et ultricies enim tellus et neque.</p>
                      <Fade in={this.state.activeKey !== "4"} >
                        <AwesomeButton type="primary" action={() => this.handleSelect("4")}>Show More #4</AwesomeButton>
                      </Fade>
                    </Thumbnail>
                  </div>
                </div>

                <div>
                  <div>
                    <Thumbnail className="my-thumbnail" src="assets/screenshot-3.jpg" alt="242x200">
                      <h3>Thumbnail #5</h3>
                      <p>Blurb #5 - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris felis sem, tristique et porta vitae, rhoncus eu turpis. Proin convallis, nisi sed feugiat cursus, orci magna euismod quam, et porttitor est mi vel nisl. Curabitur in finibus ligula, vel venenatis elit. Nulla venenatis facilisis commodo. Nam volutpat mollis tincidunt. Nullam sit amet nisl iaculis, finibus nibh a, varius est. Duis eget vestibulum erat, at porta leo. Fusce neque diam, pharetra rutrum eros vitae, rhoncus pharetra mi. Praesent mauris sem, lacinia vitae orci at, rutrum ultrices ipsum. Praesent mattis, nunc eget suscipit elementum, erat sapien lacinia metus, et ultricies enim tellus et neque.</p>
                      <Fade in={this.state.activeKey !== "5"} >
                        <AwesomeButton type="primary" action={() => this.handleSelect("5")}>Show More #5</AwesomeButton>
                      </Fade>
                    </Thumbnail>
                  </div>
                </div>
              </Row>
            </Grid> */}
          </div>
          </div>
        </div>
      );
    }
  }



// WEBPACK FOOTER //
// ./src/components/ThumbnailGridFlex.jsx